import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export enum NO_RESULTS_TYPES {
  DEFAULT = 'DEFAULT',
}

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrl: './no-results.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoResultsComponent {
  @Input() wrap: boolean = false;
  @Input() type: NO_RESULTS_TYPES = NO_RESULTS_TYPES.DEFAULT;
  @Input() text: string = '';

  protected readonly NO_RESULTS_TYPES = NO_RESULTS_TYPES;
}
